import { render, staticRenderFns } from "./orderGroupTree.vue?vue&type=template&id=553697ba&scoped=true&"
import script from "./orderGroupTree.vue?vue&type=script&lang=js&"
export * from "./orderGroupTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553697ba",
  null
  
)

export default component.exports